export const compoundInterest = (principal: number, time: number, rate: number, n: number): number => {
  const amount = principal * (Math.pow((1 + (rate / n)), (n * time)));
  const interest = amount - principal;
  return interest;
}

export const findPrincipal = (amount: number, time: number, rate: number, n: number): number => {
  const principal = amount / (Math.pow(1 + (rate / n), (n * time)))
  return principal
}